export default function OpretFraser() {
  return (
    <div className="container mx-auto mt-[-350px]">
      <div>
        <h4 className="text-dxl md:text-d2xl font-bold text-doctio-green">
          Opret og rediger mapper og fraser
        </h4>

        <p>
          I denne video demonstreres oprettelsen af en ny mappe og en ny frase.
          Efter at være logget ind, skal man enten befinde sig på siden "Mine
          fraser" eller "Tomt notat", hvor man øverst i venstre side under
          søgefeltet kan vælge "Tilføj". Her får man muligheden for at tilføje
          enten en ny mappe eller en ny frase.
        </p>

        <p>
          Vælger man "Ny mappe", tilføjes en mappe med navnet "Ny mappe" under
          punktet "Mine fraser". Ved at flytte musen over mappen og klikke på de
          tre prikker, åbnes funktionerne til mappen. Her kan man slette eller
          omdøbe mappen. Det er vigtigt at bemærke, at hvis man sletter en
          mappe, der indeholder fraser, slettes alle fraserne i mappen også. Man
          kan også vælge at omdøbe mappen til et mere passende navn, f.eks.
          "Almen praksis".
        </p>

        <p>
          Hvis man ønsker at oprette en ny frase, vælger man i stedet "Ny
          frase", og der åbnes et redigeringsvindue til den nye frase. Man giver
          frasen et navn og kan tilføje en undertitel for at differentiere den
          fra andre fraser med samme titel. Derefter vælger man hvilken mappe
          frasen skal placeres i og tilføjer tags, som kan bruges til at søge
          frasen frem på.
        </p>

        <p>
          Efter at have skrevet selve frasen og eventuelle overvejelser, medier
          og dokumenter, gemmes frasen automatisk hvert sekund. Når man er
          færdig med at oprette frasen, går man blot tilbage, og frasen er gemt
          i den valgte mappe. Hvis man fortryder og ikke ønsker at gemme frasen,
          kan man blot klikke på slet-knappen øverst, og frasen slettes.
        </p>

        <p>
          Tilbage i oversigten har hver frase en menu med funktioner, herunder
          muligheder for at redigere, flytte, slette eller dele frasen, men
          dette vil blive gennemgået i en separat video.
        </p>
      </div>

      <div className="mt-10">
        <iframe
          width="560"
          height="315"
          className="h-[200px] md:h-[600px]"
          style={{ width: "100%", borderRadius: "10px" }}
          src="https://www.youtube.com/embed/eJdEOjMag68?si=46SvzNnoSEWq3NmF"
          title="YouTube video player"
          frameBorder={0}
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
          allowFullScreen={true}
        ></iframe>
      </div>
    </div>
  );
}
